import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import PageTransition from "@/components/PageTransition";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import React from 'react';
import { usePageTitle } from '@/hooks/usePageTitle';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Add a redirect to home after a brief delay
    const redirectTimer = setTimeout(() => {
      window.location.href = "/";
    }, 10000);
    
    return () => clearTimeout(redirectTimer);
  }, [location.pathname]);

  usePageTitle('Page Not Found');

  return (
    <PageTransition>
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-50 to-white p-4">
        <div className="text-center max-w-md mx-auto">
          <h1 className="text-9xl font-extrabold text-gray-700 tracking-widest mb-6">404</h1>
          <p className="text-2xl font-medium text-gray-600 mb-8">Oops! Page not found</p>
          <p className="text-gray-500 mb-8">
            The page you are looking for might have been removed, had its name changed, 
            or is temporarily unavailable.
          </p>
          <Button asChild size="lg" className="gap-2">
            <Link to="/">
              <Home className="h-5 w-5" />
              Return to Home
            </Link>
          </Button>
        </div>
      </div>
    </PageTransition>
  );
};

export default NotFound;
